import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  if ( user) {
    return true;
  } else {
    router.navigateByUrl('/auth/login');
    return false;
  }
};

export const redirectIfAuthenticated: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('token');

  if (token) {
    router.navigateByUrl('/');
    return false;
  }
  return true;
};

